import React from 'react';
import PropTypes from 'prop-types';
import { TeamWrapper, ValuePropositions, ValueProposition } from './styled';

const Team = ({ isMobile }) => {
  return (
    <TeamWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { delay: isMobile ? 0 : 4 } }}
    >
      <ValuePropositions>
        <div>
          <ValueProposition>
            <h3>An international team united by a global mission</h3>
            <p>
              We are from 60+ different countries around the world, transcending cultural
              signaling behavior to focus on the mission at hand.
            </p>
          </ValueProposition>
          <ValueProposition>
            <h3>Flexible work environment</h3>
            <p>
              Our team members work collaboratively remotely across the globe. Other than
              a couple scheduled team meetings, you get a lot of freedom to manage how you
              work best and are the most productive.
            </p>
          </ValueProposition>
        </div>

        <div>
          <ValueProposition>
            <h3>In person gatherings in exciting locations</h3>
            <p>
              Work in-person with your smaller team or with the bigger company in places
              around the world. In the past, we’ve gone to Tulum, Madeira, Bali, Iceland
              and Colombia, just to name a few.
            </p>
          </ValueProposition>
          <ValueProposition>
            <h3>People love working at SafetyWing</h3>
            <p>
              We consistently score higher than 9/10 on the question, “Would you recommend
              working at SafetyWing to a friend?” We speak our minds and treat other
              perspectives seriously.
            </p>
          </ValueProposition>
        </div>
      </ValuePropositions>
    </TeamWrapper>
  );
};

Team.propTypes = {
  isMobile: PropTypes.bool.isRequired
};

export default Team;
